import { Abstraxion } from '@burnt-labs/abstraxion';
import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useWindowSize } from 'usehooks-ts';
import Address from '../../components/Address';
import Icons from '../../components/icons/Icons';
import LoaderLayout from '../../components/loaders/LoaderLayout';
import MintStepWrapper from '../../components/MintStepContainer/MintStepWrapper';
import { useModal } from '../../components/modal/ModalContext';
import NftViewer from '../../components/NftViewer/NftViewer';
import { useCosmos } from '../../helpers/cosmosHelper';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { useEvent } from '../events/event/EventProvider';
import ConnectWallet from '../events/event/mint/ConnectWallet';
import { useMint } from '../events/event/mint/MintNftProvider';
import { ReactComponent as MercleLogo } from './mercle.svg';
import './xion.scss';

const Xion = ({ children }) => {
  const [{ cosmosLogout, handleClose, isConnecting }] = useCosmos();
  const [{ user, isLoading }] = useGlobalState();
  const [{ steps, step }] = useMint();
  const [{ openModal, closeModal }] = useModal();

  const [{ nftProfile }] = useEvent();
  const { width } = useWindowSize();

  const hamburgerClick = () => {
    openModal({
      className: 'Hamburger-container',
      classNameContent: 'mobile_header',
      content: (
        <>
          <Link to='/' onClick={closeModal}>
            Home
          </Link>
          <Link to='/identity' onClick={closeModal}>
            Identity
          </Link>
          <Link to='/badges' onClick={closeModal}>
            Badges
          </Link>
          {/* <Link to='/invite' onClick={closeModal}>
            Invite
          </Link> */}
          {/* <Link to='/programs' onClick={closeModal}>
            Programs
          </Link> */}
          {/* <Link to='/leaderboard' onClick={closeModal}>
            Leaderboard
          </Link> */}
          <a href='https://prometheansaga.com/' target='_blank'>
            Promethean Saga
          </a>

          <div className='menu' onClick={cosmosLogout}>
            Logout
          </div>
        </>
      ),
    });
  };

  const copyAddress = () => {
    alert.info('Address copied', { autoClose: 200 });
    window.navigator.clipboard.writeText(user?.xionAddress);
  };

  const redirect = () => {
    window.open('https://mercle.xyz', '_blank');
  };

  if (isLoading || isConnecting || (nftProfile === undefined && user)) {
    return <LoaderLayout />;
  }
  // if (!user)
  //   return (
  //     <>
  //       <div className='xion-container'>
  //         <Abstraxion onClose={handleClose} />
  //         {/* <div className='xion-header'>
  //           <div className='logo'>
  //             <img src={require('./xionLogo.png')} />
  //           </div>
  //         </div> */}

  //         <div className='center-text'>
  //           <div className='text'>
  //             <div className='logo'>
  //               <img src={require('./xionLogo.png')} />
  //             </div>
  //             {/* <p className='permissioned_text'>Mainnet</p> */}

  //             <p className='profile'>Proof of <span>Identity</span></p>
  //             <p className='sub-text'>
  //               powered by
  //               <MercleLogo className='pointer' />
  //             </p>
  //           </div>
  //           <NftViewer />
  //           <div className='login_text_container'>
  //             <h1 className='login_text'>
  //               GET YOUR SOULBOUND <br />
  //               IDENTITY RELIC
  //             </h1>
  //             <p className='login_sub_text'>
  //               Join other XIONers in their journey of building identity on XION Mainnet by getting your Identity Relic! Complete rituals and make your Relic stronger.The Relic
  //               will reflect your growth, anon. Believe in something.
  //             </p>
  //           </div>
  //           <ConnectWallet />
  //         </div>
  //       </div>
  //     </>
  //   );

  if (user && !nftProfile) {
    return <MintStepWrapper>{steps?.[step || 0]}</MintStepWrapper>;
  }
  return (
    <div className='xion-container'>
      <Abstraxion onClose={handleClose} />
      <div className='xion-header'>
        <div className='logo'>
          <img src={require('./xionLogo.png')} alt='logo' />
        </div>
        {width >= 600 ? (
          <div className='routes'>
            {/* <NavLink to='/programs' className='route-link' activeClassName='active'>
              Programs
            </NavLink> */}
            <NavLink to='/' className='route-link' activeClassName='active'>
              Home
            </NavLink>
            <NavLink to='/identity' className='route-link' activeClassName='active'>
              Identity
            </NavLink>
            {/* <NavLink to='/leaderboard' className='route-link' activeClassName='active'>
              Leaderboard
            </NavLink> */}
            <NavLink to='/badges' className='route-link' activeClassName='active'>
              Badges
            </NavLink>
            {/* <NavLink to='/invite' className='route-link' activeClassName='active'>
              Invite
            </NavLink> */}
            <a href='https://prometheansaga.com/' target='_blank' className='route-link' activeClassName='active'>
              Promethean Saga
            </a>
          </div>
        ) : (
          <button className='hamburger' onClick={hamburgerClick}>
            ☰
          </button>
        )}
        {width >= 600 && (
          <div className='left-container'>
            {user && (
              <>
                <p className='elipsis green_highlighted'>
                  <Address a={user?.xionAddress} redirect={false} />
                </p>
                <div className='left-container' onClick={cosmosLogout}>
                  <Icons icon={'logout'} />
                </div>
              </>
            )}
            {!user && (
              <>
              <ConnectWallet />
              </>
            )}
          </div>
        )}
      </div>
      {children}
    </div>
  );
};

export default Xion;
